import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    headerSurround: {
        textAlign: "center",
        margin: "0 74px 30px",
    },
    heading: {
        fontSize: 26,
        fontWeight: "bold"
    },
    subHeading: {
        fontSize: 16,
        lineHeight: "22px",
        margin: 0
    },
    list: {
        fontFamily: "CircularStd",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.08)",
        padding: 0,
        '& > div.Mui-expanded': {
            margin: '2px 0'
        }
    },
    flag: {
        width: 20,
        height: 20,
        margin: "0 10px 0 0",
        display: "inline-block"
    },
    countryLabel: {
        color: "#4a4a4a",
        fontSize: 16,
        fontWeight: 600,
        verticalAlign: "top"
    },
    paragraphSurround: {
        background: "#f5f5f5",
        padding: "30px 30px 29px",
        fontSize: 16,
        color: "#4a4a4a"
    },
    directionalArrows: {
        width: 22,
        height: 22,
        position: "absolute",
        right: 20,
        top: 22
    },
    poiBulletPoints: {
        listStyle: "none",
        boxShadow: "none",
        zIndex: 3,
        "&:last-of-type": {
            marginBottom: 0
        }
    },
    poiBullet: {
        /* fontSize: 16,
        fontFamily: "CircularStd",
        fontWeight: 500,
        lineHeight: "30px", */
        display: 'flex',
        fontSize: '16px',
        fontFamily: 'CircularStd',
        fontWeight: 500,
        lineHeight: '30px',
        alignItems: 'center',
    },
    poiSummary: {
        height: '20px !important',
        padding: '25px 20px',
        minHeight: '0 !important',
    },
    poiDetails: {
        padding: "0 22px 20px",
        minHeight: 0
    }
});